
import { ReactNode } from 'react';
import Navigation from './Navigation';

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navigation />
      <main className="max-w-7xl mx-auto px-4 py-8">
        {children}
      </main>
      <footer className="bg-gray-800 text-white py-8 mt-16">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-gray-300">
            © 2024 Curso de Sistemas Logísticos Automatizados. 
            <a href="https://readdy.ai/?origin=logo" className="text-blue-400 hover:text-blue-300 ml-2 cursor-pointer">
              Powered by Readdy
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Layout;
